import { defer } from 'react-router-dom'

import { mercuryApi } from '$api'
import { CompanyPreferences } from '$utils'
import { PayrollSystem } from '$constants'
import useAppStore, { isAppStateReady } from '$appStore'
import {
  staffMemberService,
  staffRoleService,
  payClassificationService,
} from '$services'

export default async function loader({ params }) {
  // React-router loaders run in parallel, so we can't rely on the parent loader
  // that waits for the app context to have finished before the code in our child
  // loaders runs. So we need to manually wait ourselves for the app context before
  // we use it in the following line.
  await isAppStateReady()

  const { activeCompany } = useAppStore.getState()

  const payrollSystem = activeCompany?.preference(
    CompanyPreferences.PayrollSystem
  )

  const payrollPayTypes = mercuryApi
    .get(
      `payroll/pay-type/${payrollSystem ? payrollSystem : PayrollSystem.Custom}`
    )
    .then((result) => {
      return result
    })

  const ruleDetail = mercuryApi
    .get(
      `/pay-rules/packages/${params.oldPackageId}` // find the rule to copy in it's original package
    )
    .then((p) => {
      // get the specific rule we have routed to from the whole package
      return p.rules.find((rule) => rule.id === params.ruleId)
    })

  const staffMembers = staffMemberService
    .getAll(undefined, true, false)
    .then((staffMembers) =>
      staffMembers.map(({ id, name, datestampDeleted }) => ({
        id: id!,
        label: name,
        display: datestampDeleted == null,
      }))
    )

  const staffRoles = staffRoleService.getAll().then((staffRoles) =>
    staffRoles.map(({ id, name, datestampDeleted }) => ({
      id: id!,
      label: name!,
      display: datestampDeleted == null,
    }))
  )

  const payClassifications = payClassificationService
    .getAll()
    .then((payClassifications) =>
      payClassifications.map(({ id, name }) => ({
        id: id!,
        label: name!,
      }))
    )

  return defer({
    data: Promise.all([
      payrollPayTypes,
      ruleDetail,
      Promise.resolve(params.newPackageId),
      staffMembers,
      staffRoles,
      payClassifications,
    ]),
  })
}
